'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dIn$002dMaintenance from "./app.api.-Pharmacy-App-Update$-In-Maintenance.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$InMaintenance$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$InMaintenance$ as $c_Lapp_api_PharmacyAppUpdate$InMaintenance$ };
$c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$InMaintenance$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$InMaintenance$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$InMaintenance$ as $h_Lapp_api_PharmacyAppUpdate$InMaintenance$ };
$h_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype = $c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype;
$c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype.toString__T = (function() {
  return "InMaintenance";
});
$c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$InMaintenance = (function(x$0) {
  var data$4 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dIn$002dMaintenance.$c_Lapp_api_PharmacyAppUpdate$InMaintenance(data$4);
});
$c_Lapp_api_PharmacyAppUpdate$InMaintenance$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$InMaintenance(p);
});
var $d_Lapp_api_PharmacyAppUpdate$InMaintenance$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$InMaintenance$, "app.api.PharmacyAppUpdate$InMaintenance$", ({
  Lapp_api_PharmacyAppUpdate$InMaintenance$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$InMaintenance$ as $d_Lapp_api_PharmacyAppUpdate$InMaintenance$ };
var $n_Lapp_api_PharmacyAppUpdate$InMaintenance$;
function $m_Lapp_api_PharmacyAppUpdate$InMaintenance$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$InMaintenance$)) {
    $n_Lapp_api_PharmacyAppUpdate$InMaintenance$ = new $c_Lapp_api_PharmacyAppUpdate$InMaintenance$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$InMaintenance$;
}
export { $m_Lapp_api_PharmacyAppUpdate$InMaintenance$ as $m_Lapp_api_PharmacyAppUpdate$InMaintenance$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-In-Maintenance$.js.map
